import {
  GEOFENCES_RECEIVED,
  SET_GEOFENCE_NAME,
  SET_GEOFENCE_GEOJSON,
  SET_GEOFENCE_ID,
  CLEAR_GEOFENCE_STATE
} from 'actions/actionTypes';
import { createSelector } from 'reselect';


const defaultState = {
  geofences: [],
  id: '',
  name: '',
  geoJson: {}
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GEOFENCES_RECEIVED:
      return {
        ...state,
        geofences: action.payload
      };
    case SET_GEOFENCE_ID:
      return {
        ...state,
        id: action.payload
      };
    case SET_GEOFENCE_NAME:
      return {
        ...state,
        name: action.payload
      };
    case SET_GEOFENCE_GEOJSON:
      return {
        ...state,
        geoJson: action.payload
      };
    case CLEAR_GEOFENCE_STATE:
      return {
        ...state,
        ...defaultState
      };
    default:
      return state;
  }
};

export const selectGeofences = state => state.geofences.geofences;
export const selectCellId = state => state.orders.selectedCellId;
export const selectCellGeofences = createSelector(
  [selectGeofences, selectCellId],
  (geofences, cellId) => geofences.filter(geofence => geofence.cellId === cellId)
);